import Header from "@/components/hotel/Header";
import SubpageHero from "@/components/hotel/SubpageHero";
import Contact from "@/components/hotel/Contact";
import Footer from "@/components/hotel/Footer";
import SEO from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const ContactPage = () => {
  const { t } = useLanguage();
  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Kontakt"
        description="Kontaktieren Sie das ESOS Hotel Quelle in Bad Ragaz – Anfahrt, Telefon, E-Mail und Kontaktformular für Reservierungen und Anfragen."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Kontakt", path: "/contact" },
        ]}
      />
      <Header />
      <SubpageHero title={t.subpageHeroes.contact.title} subtitle={t.subpageHeroes.contact.subtitle} />
      <Contact />
      <Footer showContactForm />
    </main>
  );
};

export default ContactPage;
